import { useEffect, useState } from "react";
import { Bell, Check, X, Trash2 } from "lucide-react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";

const TYPE_LABELS = {
  friend_request: "Friend Request",
  friend_accepted: "Friend Accepted",
  session_start: "Session Started",
  session_end: "Session Ended",
  questionnaire_pending: "Questionnaire Pending",
  dm_new: "New Message",
  gm_dm_new: "GM Whisper",
  campaign_invite: "Campaign Invite",
  party_cash: "Party Cash",
};

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);

  const load = async () => {
    try { const r = await api.get("/notifications"); setItems(r.data); } catch {}
  };
  useEffect(() => {
    load();
    const id = setInterval(load, 20000);
    return () => clearInterval(id);
  }, []);

  const unread = items.filter(i => !i.read).length;

  const readAll = async () => { try { await api.post("/notifications/read-all"); load(); } catch {} };
  const readOne = async (id) => { try { await api.post(`/notifications/${id}/read`); load(); } catch {} };
  const deleteOne = async (id, e) => {
    e?.preventDefault?.(); e?.stopPropagation?.();
    try { await api.delete(`/notifications/${id}`); load(); } catch {}
  };
  const clearRead = async () => {
    try { await api.delete("/notifications?only_read=true"); load(); } catch {}
  };
  const clearAll = async () => {
    if (!window.confirm("Clear ALL notifications? This cannot be undone.")) return;
    try { await api.delete("/notifications"); load(); } catch {}
  };

  return (
    <div className="relative">
      <button data-testid="notif-bell" onClick={() => setOpen(!open)} className="relative p-2 border border-transparent hover:border-[#FFB000] transition-all">
        <Bell size={18} strokeWidth={1.5} className="amber" />
        {unread > 0 && (
          <span data-testid="notif-unread" className="absolute -top-1 -right-1 bg-[#FF2A2A] text-black mono text-[9px] font-bold w-5 h-5 flex items-center justify-center rounded-full">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="notif-panel" className="absolute right-0 top-full mt-2 w-[380px] panel max-h-[500px] overflow-hidden flex flex-col z-50">
          <div className="flex items-center justify-between p-3 border-b border-[rgba(255,176,0,0.25)] gap-2">
            <div className="label-term amber">// Notifications ({unread} new)</div>
            <div className="flex items-center gap-2">
              {unread > 0 && <button onClick={readAll} className="mono text-[10px] amber hover:underline flex items-center gap-1" data-testid="notif-mark-all"><Check size={10}/> mark all</button>}
              {items.some(i => i.read) && <button onClick={clearRead} className="mono text-[10px] text-[#A0A0A0] hover:underline flex items-center gap-1" data-testid="notif-clear-read">clear read</button>}
              {items.length > 0 && <button onClick={clearAll} className="mono text-[10px] text-[#FF2A2A] hover:underline flex items-center gap-1" data-testid="notif-clear-all"><Trash2 size={10}/> clear all</button>}
            </div>
          </div>
          <div className="overflow-y-auto">
            {items.length === 0 && <div className="p-6 mono text-xs text-[#A0A0A0] text-center">// no alerts</div>}
            {items.map(n => (
              <div key={n.id} className={`flex items-stretch border-b border-[#222] ${n.read ? "opacity-60" : ""}`}>
                <Link to={n.link || "#"} onClick={() => { setOpen(false); if (!n.read) readOne(n.id); }}
                      data-testid={`notif-${n.id}`}
                      className="block p-3 flex-1 hover:bg-[rgba(255,176,0,0.05)]">
                  <div className="flex items-center gap-2">
                    {!n.read && <span className="w-2 h-2 bg-[#4AF626] rounded-full" />}
                    <span className="label-term amber">{TYPE_LABELS[n.type] || n.type}</span>
                    <span className="ml-auto mono text-[9px] text-[#A0A0A0]">{new Date(n.created_at).toLocaleTimeString()}</span>
                  </div>
                  <div className="mono text-sm mt-1">{n.title}</div>
                  {n.body && <div className="mono text-[11px] text-[#A0A0A0] mt-0.5">{n.body}</div>}
                </Link>
                <button
                  onClick={(e)=>deleteOne(n.id, e)}
                  className="px-2 text-[#FF2A2A] hover:bg-[#FF2A2A]/10 border-l border-[#222]"
                  aria-label="dismiss"
                  data-testid={`notif-dismiss-${n.id}`}
                >
                  <X size={14}/>
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
